<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style>
  @import "../static/font-awesome/css/font-awesome.min.css";
  @import "../static/ionicons/css/ionicons.min.css";
  @import "../static/css/AdminLTE.min.css";
  @import "../static/css/skins/_all-skins.min.css";
  @import "../static/css/skins/skin-blue.min.css";
  @import "../static/css/main.css";
  @import "../static/plugins/zTree/css/zTreeStyle/metro.css";
  @import "../static/plugins/zTree/css/zTreeStyle/zTreeStyle.css";
</style>



// WEBPACK FOOTER //
// src/App.vue